import React, { useEffect, useState } from "react";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import {
  LinearProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import DataTable from "./data-table";

export const PinTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState();
  const [pinPlace, setPinPlace] = useState();
  const [filtersChanged, setFiltersChanged] = useState(false);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    setFiltersChanged(true);
  };

  const handlePinPlaceChange = (event) => {
    setPinPlace(event.target.value);
    setFiltersChanged(true);
  };

  const getPins = async () => {
    setIsLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.PinsAdvertising.View}?per_page=${rowsPerPage}&page=${
        currentPage + 1
      }${status && status !== "null" ? `&status=${status}` : ""}${
        pinPlace && pinPlace !== "null" ? `&pin_place=${pinPlace}` : ""
      }`,
      hasToken: true,
    });
    if (response) {
      setData(response);
    } else {
      setData([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      getPins();
    }
  }, [filtersChanged, currentPage, rowsPerPage]);

  return (
    <div>
      {/* Filter Section */}
      <div className="flex justify-between items-center mb-4 gap-4">
        <FormControl fullWidth>
          <InputLabel id="status-select-label">Status</InputLabel>
          <Select
            labelId="status-select-label"
            id="status-select"
            value={status}
            onChange={handleStatusChange}
            label="Status"
            sx={{ textAlign: "start" }}
          >
            <MenuItem value="null">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="complete">Complete</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="pin-place-select-label">Pin place</InputLabel>
          <Select
            labelId="pin-place-select-label"
            id="pin-place-select"
            value={pinPlace}
            onChange={handlePinPlaceChange}
            label="Pin place"
            sx={{ textAlign: "start" }}
          >
            <MenuItem value="null">All</MenuItem>
            <MenuItem value="top">Top</MenuItem>
            <MenuItem value="down">Down</MenuItem>
          </Select>
        </FormControl>
      </div>

      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable
              data={data?.data}
              setData={setData}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              status={status}
              pinPlace={pinPlace}
            />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data.pagination.total_page}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
